import { jsx as _jsx } from "react/jsx-runtime";
import { useConfig } from "../../../hooks/useConfig";
import { CardImage, ImageWrapper } from "./AccountImage.style";
var AccountImage = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? "Card image" : _b;
    var hosts = useConfig().hosts;
    var source = src || "".concat(hosts.assets, "/assets/cardArt/syf_generic_card.svg");
    return (_jsx(ImageWrapper, { children: _jsx(CardImage, { src: source, alt: alt }) }));
};
export default AccountImage;
//# sourceMappingURL=AccountImage.js.map